export const APARTMENTS = [
  { id: "bilocale", locali: 2, mq: 61, prezzo: 250000, prezzoFrom: true, img: "/assets/bilocale-living.jpg", planImg: "/assets/plans/plan-bilocale.jpg" },
  { id: "bilocale-cucina", locali: 2, mq: 90, prezzo: 300000, prezzoFrom: false, img: "/assets/giardino.jpg", planImg: "/assets/plans/plan-bilocale-cucina.jpg" },
  { id: "trilocale", locali: 3, mq: 106, prezzo: 380000, prezzoFrom: false, img: "/assets/trilocale-living.jpg", planImg: "/assets/plans/plan-trilocale.jpg" },
  { id: "attico", locali: 4, mq: 116, prezzo: 450000, prezzoFrom: false, img: "/assets/terrazzo-attico.jpg", planImg: "/assets/plans/plan-attico.jpg" },
];

export const EXTRAS = { box: 30000, cantina: 10000 };

export const HERO_IMAGE = "/assets/bordighera-hero.jpg";

export const GALLERY_IMAGES = [
  { src: "/assets/facciata.jpg", cls: "md:col-span-5 aspect-[3/4]", arch: true },
  { src: "/assets/camera.jpg", cls: "md:col-span-4 aspect-[3/4]" },
  { src: "/assets/cucina.jpg", cls: "md:col-span-3 aspect-[3/4]" },
  { src: "/assets/render-piscina.jpg", cls: "md:col-span-7 aspect-[16/10]" },
  { src: "/assets/aerea.jpg", cls: "md:col-span-5 aspect-[16/10]" },
];

export const LOCATION_IMAGE = "/assets/lungomare.jpg";

export const CONTACTS = {
  indirizzo: "Via Mameli / Via Pasteur — Bordighera (IM)",
  telefono: "+39 0184 716729",
  email: "info@dimoredelsole.com",
};

export const WHATSAPP = { number: "393287139722" };

export const BROCHURE_URL = "/brochure.pdf";
